import Modal from "../Modal";
import CompanyBranchEditForm from "../../forms/company/CompanyBranchEditForm";
import { useTranslation } from "../../../hooks/useTranslation";
import {useUsersStore} from "../../../store/users.store";
import {useCompanyStore} from "../../../store/company.store";
import {useEffect, useState} from "react";
import {useAuthStore} from "../../../store/auth.store";
import {useCompany} from "../../../hook/partner/company.partner.hook";
import {useUsers} from "../../../hook/partner/users.partner.hook";
import {PartnerApi} from "../../../api/partner.api";
import {toast} from "react-toastify";

export default function CompanyBranchPeoplesModal({show, handleClose, company_id, company_branch, users, callback, title = null}) {
    const { t } = useTranslation();
    const token = useAuthStore((state) => state.token);

    /*const companyMutation = useCompany();
    const usersMutation = useUsers();

    const token = useAuthStore((state) => state.token);
    const user = useAuthStore((state) => state.user);
    const users = useUsersStore((state) => state.users);
    const company = useCompanyStore((state) => state.company);
    const [reload, setReload] = useState(0);


    useEffect(() => {
        if (user && token && company_id) {
            companyMutation.mutate({
                token, company_id
            })
            usersMutation.mutate({
                token,
            });
        }
    }, [user, token, reload]);

    let company_branch = company.branches.find((b)=>b.company_branch_id == company_branch_id);
*/

    const addToBranch = function (person_id) {

        const result = PartnerApi.companyCompanyBranchAddPerson({
            token,
            person_id,
            company_id,
            company_branch_id: company_branch.company_branch_id
        });
        result.then((result) => {
            if ("error" in result) {
                toast.error(result.error);
                return;
            }
            toast.success(t("common.saved"));

            callback();
        });
        return false;
    }

    const deleteFromBranch = function (person_id) {

        const result = PartnerApi.companyCompanyBranchDeletePerson({
            token,
            person_id,
            company_id,
            company_branch_id: company_branch.company_branch_id
        });
        result.then((result) => {
            if ("error" in result) {
                toast.error(result.error);
                return;
            }
            toast.success(t("common.saved"));

            callback();
        });
        return false;
    }

    const defaultTitle = t("companyBranch.edit")+" - "+company_branch.name;
    return (
        <Modal title={title || defaultTitle} show={show} handleClose={handleClose}>
            <div className="row">
                <div className="col-6">
                    <h5>Nejsou v pobočce</h5>
                    {users?.length > 0 && users.filter(user=>(
                        !company_branch.peoples.includes(user.person_id)
                    )).map(user=>(
                        <div>
                            <button className="btn"
                            onClick={()=>addToBranch(user.person_id)}
                            >
                            {user.first_name+" "+user.last_name}
                            </button>
                        </div>
                    ))}
                </div>
                <div className="col-6">
                    <h5>Jsou v pobočce</h5>
                    {users?.length > 0 && users.filter(user=>(
                        company_branch.peoples.includes(user.person_id)
                    )).map(user=>(
                        <div>
                            <button className="btn"
                                    onClick={()=>deleteFromBranch(user.person_id)}
                            >
                            {user.first_name+" "+user.last_name}
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};